import React from 'react';
import { useDispatch } from 'react-redux';
import _ from 'lodash';

import { BUSINESS_UNIT_TYPES } from '../../../../../../../../../../utils/constants/business-unit-types';
import { initWideFormOrderLine, initWideFormProduct, toggleWideFormDrawer } from '../../../../../../../../../../slices/WideForm/wideFormSlice';
import { OrderProduct } from '../../../../../../../../../../api-client';
import { orderTotalBySizes } from '../../../../../../../../../../utils/data-format-enchanters/order-products-enchanter';

import './bv-delivery-group-card.scss';

interface IBVDeliveryGroupCard {
    disabled: boolean;
    orderProduct: OrderProduct;
}

const BVDeliveryGroupCard: React.FunctionComponent<IBVDeliveryGroupCard> = ({ disabled, orderProduct }) => {
    const dispatch = useDispatch();

    const _handleDeliveryCardClick = () => {
        if (disabled) {
            return;
        }

        if (orderProduct.id && orderProduct.rowId) {
            dispatch(initWideFormOrderLine(orderProduct.rowId));
            dispatch(initWideFormProduct(orderProduct.id));
            dispatch(toggleWideFormDrawer(true));
        }
    }

    return (
        <div className={`bv-delivery-group-card ${disabled && 'delivery-group-card-disabled'}`} onClick={_handleDeliveryCardClick}>
            <div className="delivery-card-quantity">
                <span>
                    {_.map(orderProduct.sizes, x => x.quantity).reduce((prev, next) => (prev || 0) + (next || 0))}
                </span>
            </div>

            <div className="delivery-card-image">
                <img src={orderProduct.imageUrl} alt={orderProduct.name} />
            </div>
            <div className="delivery-card-body">
                <span className="card-heading">
                    {orderProduct.name}
                </span>
                <span className="card-secondary-heading">
                    {orderProduct.businessUnitCode === BUSINESS_UNIT_TYPES.JEWELRY_CODE
                        ? 'CatCode: '
                        : 'SapCode: '
                    }
                    {orderProduct.businessUnitCode === BUSINESS_UNIT_TYPES.JEWELRY_CODE
                        ? orderProduct.catalogCode
                        : orderProduct.sizes && orderProduct.sizes[0].sapCode
                    }
                </span>
            </div>

            {orderProduct.limitedEditionCode &&
                <div className="delivery-card-limited">
                    <span>
                        {orderProduct.limitedEditionCode}
                    </span>
                </div>
            }

            <div className="delivery-card-total">
                <span>
                    {orderTotalBySizes(orderProduct.sizes).amountFormat}
                </span>
            </div>
        </div>
    );
}

export default BVDeliveryGroupCard;